// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zcwy6","inner":"styles_inner__sinHe","providers":"styles_providers__uHVWB"};